import { AfterViewInit, Component, HostListener, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { AccountActions } from '@app/core/actions';
import * as fromRoot from '@app/reducers';
import { Identity } from '@app/shared/models/identity';
import { DialogService } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ModalUpdateComponent } from '../modals/modal-update/modal-update.component';
import { isPlatformBrowser } from '@angular/common';


@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss'],

})
export class TopNavComponent implements OnInit, AfterViewInit {

  @Input() identity: Identity;

  route$: Observable<any>;
  pendingUpdates$: Observable<any>;

  dropdownProfileToggled = false;
  dropdownIdentitiesToggled = false;
  needUpdate = false;

  constructor(
    private readonly router: Router,
    private readonly store$: Store<fromRoot.State>,
    private dialog: DialogService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {

    if (isPlatformBrowser(this.platformId)) {
      this.route$ = this.store$.select(fromRoot.getRoute);
    }
    this.pendingUpdates$ = this.store$.select(fromRoot.getPendingUpdates);
  }

  ngOnInit() { }

  ngAfterViewInit() {
    this.pendingUpdates$.subscribe(res => {
      if (res && res.length) {
        this.needUpdate = true;
        this.dialog.open(ModalUpdateComponent, {
          closeButton: false,
          enableClose: false,
          size: 'sm'
        });
      } else {
        this.needUpdate = false;
      }
    });
  }

  toggleDropdownIdentities(): void {
    this.dropdownIdentitiesToggled = !this.dropdownIdentitiesToggled;
    this.dropdownProfileToggled = false;
  }

  toggleDropdownProfil(): void {
    this.dropdownProfileToggled = !this.dropdownProfileToggled;
    this.dropdownIdentitiesToggled = false;
  }

  private resolveDropDownProfileState(event) {
    if (!event.target.classList.contains('top-nav-items-profil') &&
      !event.target.classList.contains('top-nav-items-profil-label') &&
      !event.target.classList.contains('icon-smash_profil')) {
      this.dropdownProfileToggled = false;
    }
  }

  private resolveDropDownTeamsState(event) {
    if (!event.target.classList.contains('top-nav-items-identities-selected') &&
      !event.target.classList.contains('icon-smash_expand_arrow')) {
      this.dropdownIdentitiesToggled = false;
    }
  }

  @HostListener('document:click', ['$event'])
  clickHandlerDropdownProfile(event) {
    this.resolveDropDownProfileState(event);
    this.resolveDropDownTeamsState(event);
  }

  goToProfileSettings(): void {
    this.router.navigateByUrl('/account/profile');
  }

  signOut() {
    this.store$.dispatch(AccountActions.signOut());
  }
}
